import React, { useEffect, useState } from 'react';
import { SalePhaseData } from '../model/model';
import FormBox from './subcomponents/FormBox';
import Phase from './subcomponents/Phase';
import styled from 'styled-components';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';


const SalePhasesContainer = styled.div`
    display: flex;
    padding: 1rem;
    flex-direction: column;
    align-items: center;
`;

const Row = styled.div`
    display: flex;
    width: 100%;
`
const EmptySpace = styled.span`
    display: flex;
    width: 100%;
    flex: 1;
`;

const HeaderContainer = styled.div`
    display: flex;
    flex: 15;
    width: 100%;
    align-items: center;
    margin-bottom: 1rem;
`;

const HeaderItem = styled.span`
    flex: 1;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
`;

const ButtonContainer = styled.div`
    display: flex;
    width: 100%;
    flex: 1;
    padding-top: 0.75rem;
`;

const StyledAddIcon = styled(AddCircleOutlineIcon)`
    color: #58585A;
    cursor: pointer;
    margin-left: 1rem;
`;

const StyledRemoveIcon = styled(RemoveCircleOutlineIcon)`
    color: #58585A;
    cursor: pointer;
    margin-left: 1rem;
`;

const Title = styled.span`
    font-family: 'Grold', sans-serif;
    font-size: 1rem;
    font-weight: 800;
`;

interface SalePhasesProps {
    salePhases: SalePhaseData[];
    onSalePhasesChange: (salePhases: SalePhaseData[]) => void;
}
const SalePhases: React.FC<SalePhasesProps> = ({ salePhases, onSalePhasesChange }) => {
    const [phases, setPhases] = useState<SalePhaseData[]>(salePhases);

    useEffect(() => {
        onSalePhasesChange(phases);
    }, [phases])

    const handlePhaseChange = (index: number, updatedPhase: SalePhaseData) => {
        const updatedPhases = [...phases];
        updatedPhases[index] = updatedPhase;
        setPhases(updatedPhases);
        onSalePhasesChange(updatedPhases);
    };

    const handleNewPhaseAddition = () => {
        const newPhase = {
            uniqueId: `phase_${Date.now()}`,
            phaseNumber: phases.length + 1,
            durationInDays: phases[phases.length - 1]?.durationInDays,
            soldItemsCount: phases[phases.length - 1]?.soldItemsCount,
            salePriceGross: phases[phases.length - 1]?.salePriceGross,
            specialZoneMart: phases[phases.length - 1]?.specialZoneMart,
            isSpecialZoneMulti: phases[phases.length - 1]?.isSpecialZoneMulti,
            highlight: phases[phases.length - 1]?.highlight,
            isPromoted: phases[phases.length - 1]?.isPromoted,
            includesCoinsCost: phases[phases.length - 1]?.includesCoinsCost,
            allegroAdsBudgetGross: phases[phases.length - 1]?.allegroAdsBudgetGross,
        };
        setPhases([...phases, newPhase]);
    };

    const handlePhaseRemoval = (index: number) => {
        const updatedPhases = phases.filter((_, i) => i !== index).map((phase, idx) => ({
            ...phase,
            phaseNumber: idx + 1
        }));
        setPhases(updatedPhases);
    };

    return (
        <>
            <Title>KROK 3 <br /> SZCZEGÓŁOWE PARAMETRY SPRZEDAŻY</Title>
            <FormBox variant='standard' headerVariant="title" headerTitle="FAZY SPRZEDAŻY" width='100%'>
                <SalePhasesContainer>
                    <Row>
                        <HeaderContainer>
                            <HeaderItem>Faza sprzedaży</HeaderItem>
                            <HeaderItem>Czas trwania</HeaderItem>
                            <HeaderItem>Liczba</HeaderItem>
                            <HeaderItem>Cena sprzedaży<br />(Brutto)</HeaderItem>
                        </HeaderContainer>
                        <EmptySpace />
                    </Row>
                    {phases.map((phase, index) => (
                        <Row key={phase.uniqueId}>
                            <Phase
                                salePhase={phase}
                                onPhaseChange={(updatedPhase) => handlePhaseChange(index, updatedPhase)}
                            />
                            {//if is first phase and is the only phase
                                (index === 0 && phases.length === 1) &&
                                <ButtonContainer>
                                    <StyledAddIcon onClick={handleNewPhaseAddition} />
                                </ButtonContainer>
                            }

                            {//if is first phase and there is more than 1 phase
                                (index === 0 && phases.length > 1) &&
                                <ButtonContainer>
                                    <StyledRemoveIcon onClick={() => handlePhaseRemoval(index)} />
                                </ButtonContainer>
                            }

                            {//if is middle phase
                                (index !== 0 && index !== phases.length - 1) &&
                                <ButtonContainer>
                                    <StyledRemoveIcon onClick={() => handlePhaseRemoval(index)} />
                                </ButtonContainer>
                            }

                            {//if is last phase and there are less than 10 phases
                                (index !== 0 && index === phases.length - 1 && phases.length < 10) &&
                                <ButtonContainer>
                                    <StyledAddIcon onClick={handleNewPhaseAddition} />
                                </ButtonContainer>
                            }

                            {//if is last phase and there are 10 phases
                                (index !== 0 && index === phases.length - 1 && phases.length === 10) &&
                                <ButtonContainer>
                                    <StyledRemoveIcon onClick={() => handlePhaseRemoval(index)} />
                                </ButtonContainer>
                            }
                        </Row>
                    ))}
                </SalePhasesContainer>
            </FormBox>
        </>
    );
};

export default SalePhases;